import type { ReportSession, ReportTrackingEvent } from '../types/expertReportTracking'
import { getReportTimeSpentEvent } from './getReportTimeSpentEvent'

interface ClosedReportSession {
  session: ReportSession | undefined
  timeSpentEvent: ReportTrackingEvent | undefined
}

/**
 * Ends a report visit with its Time Spent event. A visit is only ever closed once, so the several signals that can
 * end it (`beforeunload`, `pagehide`, leaving the report, unmount) produce a single event between them.
 */
export const closeReportSession = (session: ReportSession | undefined, now: number): ClosedReportSession => {
  if (!session || session.isClosed) {
    return { session, timeSpentEvent: undefined }
  }

  return { session: { ...session, isClosed: true }, timeSpentEvent: getReportTimeSpentEvent(session, now) }
}
